import styled from 'styled-components';

import Button from 'components/shared/Button';
import MobileOnly from 'components/shared/responsiveness/MobileOnly';
import { useMobileNavigationActions } from 'stores/mobileNavigationStore';
import { colors } from 'styles/theme/colors';
import HamburgerMenuIcon from 'svg/HamburgerMenuIcon';

export default function AdminMobileMenuButton() {
  const { setNavigationOpen } = useMobileNavigationActions();

  return (
    <MobileOnly>
      <MenuButton variant='icon' onClick={() => setNavigationOpen(true)} data-cy='hamburgerIconButton'>
        <HamburgerMenuIcon color={colors.black} />
      </MenuButton>
    </MobileOnly>
  );
}

const MenuButton = styled(Button)`
  flex-shrink: 0;
`;
